<template>
  <b-card>
    <div class="animated fadeIn">
      <b-row class="mb-3">
        <b-col>
          <b-input v-model="keyword" :placeholder="t(['Search','ຊອກຫາ'])" />
        </b-col>
        <b-col class="text-right">
          <b-button
            @click="add()"
            v-b-modal.modal
            v-b-tooltip.hover
            :title="t(['Add','ເພີ່ມ'])"
            variant="success"
          >
            <i class="fa fa-plus"></i>
          </b-button>
        </b-col>
      </b-row>
      <b-table
        caption-top
        :items="filteredItems"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        head-variant="dark"
      >
        <template slot="index" slot-scope="data">{{ data.index + 1 }}</template>
        <template slot="image" slot-scope="data">
          <b-img-lazy :src="data.item.image" style="width: 100px" />
        </template>

        <template slot="active" slot-scope="data">
          <b-badge variant="success" v-if="data.item.active">Active</b-badge>
          <b-badge variant="danger" v-if="!data.item.active">In-Active</b-badge>
        </template>

        <template slot="actions" slot-scope="data">
          <b-button-group>
            <b-button
              @click="edit(data.item)"
              v-b-modal.modal
              size="sm"
              v-b-tooltip.hover
              :title="t(['Edit','ແກ້ໄຂ'])"
              variant="warning"
            >
              <i class="fa fa-pencil"></i>
            </b-button>
            <b-button
              @click="remove(data.item)"
              v-b-modal.modal
              size="sm"
              v-b-tooltip.hover
              :title="t(['Remove','ລຶບ'])"
              variant="danger"
            >
              <i class="fa fa-trash"></i>
            </b-button>
          </b-button-group>
        </template>
      </b-table>

      <b-pagination
        v-if="filteredItems && filteredItems.length > 0"
        v-model="currentPage"
        :total-rows="filteredItems.length"
        :limit="10"
        align="center"
        size="sm"
        class="mt-3"
      />

      <b-modal
        size="lg"
        :no-close-on-backdrop="true"
        id="modal"
        v-if="item"
        :title="item.id ? t(['Edit Promotion','ແກ້ໄຂໂປຣໂມຊັນ']):t(['Add Promotion','ເພີ່ມໂປຣໂມຊັນ'])"
        :header-bg-variant="item.id ? 'warning':'success'"
        ok-title="Save"
        @ok="save()"
      >
        <b-row>
          <b-col>
            <b-form-group :label="t(['Name','ຊື່'])">
              <b-form-input v-model="item.name" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group :label="t(['Name English','ຊື່ອັງກິດ'])">
              <b-form-input v-model="item.nameEn" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group :label="t(['Start Date','ວັນທີ່ເລີ່ມ'])">
              <b-form-input v-model="item.start" type="date" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group :label="t(['End Date','ຮອດວັນທີ'])">
              <b-form-input v-model="item.end" type="date" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group :label="t(['Image','ຮູບ'])">
              <b-form-file @change="upload()" id="image" />
              <b-img-lazy v-if="item.image" :src="item.image" style="width: 100%" />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group :label="t(['Descriptions','ຄຳແະທິບາຍ'])">
              <b-form-textarea v-model="item.descriptions" :rows="6"></b-form-textarea>
            </b-form-group>

            <b-form-group :label="t(['Status','ສຖຸານະ'])">
              <b-form-radio v-model="item.active" :value="false">In-Active</b-form-radio>
              <b-form-radio v-model="item.active" :value="true">Active</b-form-radio>
            </b-form-group>
          </b-col>
        </b-row>
      </b-modal>
    </div>
  </b-card>
</template>

<script>
import firebase from "firebase";
import Swal from "sweetalert2";
import Datepicker from "vuejs-datepicker";

export default {
  name: "Promotions",
  components: { Datepicker },
  computed: {
    filteredItems: function() {
      if (this.keyword)
        return _.filter(this.items, i => {
          if (this.match(this.keyword, i.name)) return true;
          if (this.match(this.keyword, i.nameEn)) return true;
          return false;
        });
      else return this.items;
    },
    sortOptions() {
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  data() {
    return {
      collection: null,
      items: null,
      item: null,
      storage: null,
      keyword: null,
      fields: [
        { key: "index", label: "#" },
        { key: "image", label: this.t(["image", "ຮູບ"]), sortable: true },
        { key: "name", label: this.t(["name", "ຊື່"]), sortable: true },
        {
          key: "nameEn",
          label: this.t(["nameEn", "ຊື່ອັງກິດ"]),
          sortable: true
        },
        {
          key: "start",
          label: this.t(["start", "ວັນທີ່ເລີ່ມ"]),
          sortable: true
        },
        { key: "end", label: this.t(["end", "ຮອດວັນທີ"]), sortable: true },
        { key: "active", label: this.t(["active"]), sortable: true },
        { key: "actions", label: this.t(["actions"]), class: "text-right" }
      ],
      currentPage: 1,
      perPage: 20,
      sortDesc: false,
      sortDirection: "asc",
      sortBy: "",
      filter: null
    };
  },
  mounted() {
    this.collection = firebase.firestore().collection("promotions");
    this.storage = firebase.storage().ref("/promotions");
    this.gets();
  },
  methods: {
    gets() {
      Swal.showLoading();
      this.collection.onSnapshot(snapshot => {
        let items = [];
        snapshot.forEach(doc => {
          let item = doc.data();
          item.id = doc.id;
          if (item.startDate)
            item.start = this.moment(
              new Date(item.startDate.seconds * 1000)
            ).format("YYYY-MM-DD");
          if (item.endDate)
            item.end = this.moment(
              new Date(item.endDate.seconds * 1000)
            ).format("YYYY-MM-DD");
          items.push(item);
        });
        this.items = items;
      });
      Swal.close();
    },
    add() {
      this.item = {
        start: this.moment(new Date()).format("YYYY-MM-DD"),
        end: this.moment(new Date()).format("YYYY-MM-DD"),
        active: true
      };
    },
    edit(item) {
      this.item = item;
    },
    save() {
      if (this.item.start)
        this.item.startDate = firebase.firestore.Timestamp.fromDate(
          new Date(this.item.start)
        );
      if (this.item.end)
        this.item.endDate = firebase.firestore.Timestamp.fromDate(
          new Date(this.item.end)
        );
      if (this.item.id) {
        this.collection.doc(this.item.id).update(this.item);
      } else {
        this.item.id = this.item.name;
        this.collection.add(this.item);
      }
      this.gets();
    },
    remove(item) {
      Swal.fire(this.swalconfirm()).then(res => {
        if (res.value) {
          this.collection.doc(item.id).delete();
          this.gets();
        }
      });
    },
    async upload() {
      const file = document.getElementById("image").files[0];
      const ref = this.storage.child(file.name);
      await ref.put(file);
      ref.getDownloadURL().then(url => {
        this.item.image = url;
      });
    }
  }
};
</script>

<style>
.vdp-datepicker input {
  width: 100%;
}
</style>
